/**
 * Dateiname aus `Content-Disposition` (`filename*=UTF-8''…` vor `filename=…`); ohne lesbaren Namen
 * `null` – der Aufrufer wählt dann selbst einen.
 */
export function attachmentFileName(header: string | null): string | null {
  if (!header) return null;
  const encoded = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(header)?.[1];
  if (encoded) {
    try {
      return decodeURIComponent(encoded.trim());
    } catch {
      // Kaputt kodiert: dann zählt der einfache Name.
    }
  }
  const plain = /filename\s*=\s*("([^"]*)"|[^;]+)/.exec(header);
  const name = (plain?.[2] ?? plain?.[1])?.trim();
  return name ? name : null;
}
